import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LoadingController, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { AlertService } from 'src/app/services/alert.service';
import { ApiService } from 'src/app/services/api.service';
import { FirestoreService } from 'src/app/services/firestore.service';
import { ToastService } from 'src/app/services/toast.service';
import { IParent } from 'src/app/shared/types/user.model';

@Component({
  selector: 'app-add-parents',
  templateUrl: './add-parents.component.html',
  styleUrls: ['./add-parents.component.scss'],
})
export class AddParentsComponent implements OnInit {
  dataForm: FormGroup;
  showWarnings: boolean = false;
  unsubscribe = new Subject();
  uploadPercentage: string = '0';
  profileImageUrl;

  imageUrl: string = '';
  imageEvent: string = '';
  imagePreview = null;

  @Input('data') data;
  @Input('isEditing') isEditing;

  constructor(
    private formBuilder: FormBuilder,
    private loadingCtrl: LoadingController,
    private firestoreService: FirestoreService,
    private toastService: ToastService,
    private modalCtrl: ModalController,
    private apiService : ApiService,
    private alertService : AlertService
  ) {}

  ngOnInit() {
    this.dataForm = this.formBuilder.group({
      name: new FormControl('', Validators.compose([Validators.required])),
      address: new FormControl('', Validators.compose([Validators.required])),
      phone: new FormControl('', Validators.compose([Validators.required])),
      email: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        ])
      ),
      temporaryPassword : new FormControl('', Validators.compose([Validators.required, Validators.minLength(6)]))
    });
    if (this.data) {
      console.log('Dtata here', this.data);
      this.dataForm.patchValue(this.data);
      this.imageUrl = this.data.photoUrl;
    }
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }

  async addData() {
    this.showWarnings = true;
    console.log(this.dataForm);

    if (this.dataForm.valid) {
      this.loadingCtrl
        .create({ keyboardClose: true, cssClass: 'loading-ctrl' })
        .then(async (loadingEl) => {
          loadingEl.present();

          if (this.isEditing) {
            let data: IParent = {
              ...this.dataForm.value,
              updatedDate: new Date(),
            };
            this.firestoreService
              .updateDocument(this.firestoreService.PARENTS, this.data.id, data)
              .subscribe((res) => {
                loadingEl.dismiss();
                this.toastService.presentToast('Parent updated');
                this.modalCtrl.dismiss();
              });
          } else {
            let data: IParent = {
              ...this.dataForm.value,
              addedDate: new Date(),
            };
            this.apiService.registerParents(data).subscribe(res=>{
              loadingEl.dismiss();
                  this.toastService.presentToast('Parent added');
                  this.modalCtrl.dismiss();
            },(err=>{
              loadingEl.dismiss();
              console.log("Error", err);
              this.alertService.showFirebaseAlert(err);
            }))
          }
        });
    } else {
      this.toastService.presentToast(
        'All the fields should be filled and valid'
      );
    }
  }
}
